import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
    const [totalMRP, setTotalMRP] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [promoCodeDiscount, setPromoCodeDiscount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [validPromoCode, setValidPromoCode] = useState(true);
    const [promoCode, setPromoCode] = useState('');
    const dispatch = useDispatch();
    
    
    const getData = () => {
        setLoading(true);
        if (localStorage.getItem("cart")){
            var rree = JSON.parse(localStorage.getItem("cart"));
            setLoading(false);
            setTotalMRP(0);
            setDiscount(0);
            rree.map(el => {
                if(!el.quantity){
                    el.quantity = 1;
                }
                setTotalMRP((prev) => prev + (Number(el.crossed_price) * Number(el.quantity)))
                setDiscount((prev) => prev + ((Number(el.crossed_price) - (Number(el.actual_price)*(1-(Number(el.discount)/100)))) * Number(el.quantity)))
            })
            setCartData(rree);
        }
    }
    const deleteAll = () => {;
        localStorage.removeItem("cart");
    }

    const ApplyPromoCode = () => {
        if (promoCode === 'CASHDISCOUNT') {
            setPromoCodeDiscount(((totalMRP - discount) * 10) / 100)
            setValidPromoCode(true);
        }
        else if((promoCode === 'FREEDELIVERY')){
            setPromoCodeDiscount(80)
            setValidPromoCode(true);
        }
        else if((promoCode === 'NEWUSER')){
            setPromoCodeDiscount(300)
            setValidPromoCode(true);
        }
        else {
            setValidPromoCode(false);
        }
    }

    return <AppContext.Provider value={{ promoCode, deleteAll, setPromoCode, validPromoCode, setValidPromoCode, ApplyPromoCode, cartData, setCartData, error, setError, loading, setLoading, totalMRP, setTotalMRP, discount, setDiscount, promoCodeDiscount, setPromoCodeDiscount, getData }}>{children}</AppContext.Provider>
}